import { render, staticRenderFns } from "./WvSteakHouseCocktailItem.vue?vue&type=template&id=6374aa95&scoped=true"
import script from "./WvSteakHouseCocktailItem.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseCocktailItem.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseCocktailItem.vue?vue&type=style&index=0&id=6374aa95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6374aa95",
  null
  
)

export default component.exports